
angular.module('mtic.components.login')
.component('mticPostIamRegistrationModule', {

  templateUrl: 'template.html',

  bindings: {
    countries: '<',
    selections: '=',
  },

  controllerAs: 'selection',

  controller($scope, $log, language, api) {

    // this
    const selection = this;

    // event manager


    // model
    const text = $scope.text = {
      WELCOME: `Welcome {{firstName}} {{lastName}}, please proceed to choose your school below.`,
      TITLE: 'Microsoft Login',
      INVALIDACCOUNT: `Invalid Account Type!`,
      SCHOOL: 'School',
      COUNTRY: 'Country',
      CONTINUE: 'Continue',
      IAMEMAIL: 'IAM Email'
    }

    selection.country = {
      selected: null,
      list: [],
      set(countries) {
        $log.debug('[[mticPostIamRegistrationModule]] countries set', countries)
        this.list = countries;
        this.selected = countries[0];
        selection.moduleType.set(this.selected);
      }
    }

    selection.moduleType = {
      hide: true,
      selected: null,
      list: [],
      set: function(country) {
        $log.debug('[[mticPostIamRegistrationModule]] moduleType set', country)
        var firstSubId = country.children[0].children[0].id;
        api.getNoSchoolClasses(firstSubId)
        .then(function (classes) {
          selection.moduleType.hide = false;
          selection.moduleType.list = classes;
          selection.moduleType.selected = null;
        })
      },
      isSelected: function(moduleType) {
        return selection.moduleType.selected ? (moduleType.id === selection.moduleType.selected.id) : false;
      },
      filter: {}
    }

    selection.selectModule = function() {
      throw new Error('Did not `init` mticPostIamRegistrationSchool!');
    }

    selection.$onInit = function() {
      selection.country.set(selection.countries);
      selection.selectModule = function(moduleType) {
        selection.selections.selectModule(moduleType)
        selection.moduleType.selected = moduleType
        selection.moduleType.filter.description = moduleType.name
      }
    }
    
    selection.$onChange = function() {
      selection.country.set(selection.countries);
    }

  }
})
